import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Row,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { useForm } from "antd/es/form/Form";
import { BsCloudUpload } from "react-icons/bs";
import { encodeBase64File } from "../../../utils/encodeBase64";
import DoctorService from "../../../Services/DoctorService";
import { PlusOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStateList,
  fetCountryList,
} from "../../../Redux/actions/CommonActions";
import StateMasterService from "../../../Services/StateMasterService";

function Index({ closeModal }) {
  const [form, setForm] = useForm();
  const [componentDisabled, setComponentDisabled] = useState(true);
  const [doctorStamp, setDoctorStamp] = useState(null);
  const [doctorSignature, setDoctorSignature] = useState(null);
  const [isDoctorStampEnabled, setIsDoctorStampEnabled] = useState(false);
  const [isDoctorSignEnabled, setIsDoctorSignEnabled] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [doctorData, setDoctorData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);

  const getStateList = async (payload) => {
    await StateMasterService.StateMaster(payload).then((res) => {
      setStates(res.data);
    });
  };

  const getCountryList = async (payload) => {
    await StateMasterService.CountryMaster(payload).then((res) => {
      setCountries(res.data);
    });
  };

  useEffect(() => {
    let payload = {
      status: 1,
    };

    getCountryList(payload);
  }, []);

  let loginData = sessionStorage.getItem("login_result");
  let loginDataObject = loginData ? JSON.parse(loginData) : null;

  const handleChange = (type) => {
    if (type === "Stamp") {
      setIsDoctorStampEnabled(!isDoctorStampEnabled);
    } else {
      setIsDoctorSignEnabled(!isDoctorSignEnabled);
    }
  };

  const salutationOptions = [
    {
      value: "Mr.",
      label: "Mr.",
    },
    {
      value: "Ms.",
      label: "Ms.",
    },
    {
      value: "Mrs.",
      label: "Mrs.",
    },
  ];

  const handleKeyPress = (e) => {
    const allowedKeys = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
    ];
    if (!allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const maritalStatusOptions = [
    { label: "Married", value: "M" },
    { label: "Unmarried", value: "U" },
  ];

  const initialValues = {
    userId: loginDataObject ? loginDataObject.user.userId : "",
    salutation: loginDataObject ? loginDataObject.user.salutation : "",
    firstName: loginDataObject ? loginDataObject.user.firstName : "",
    lastName: loginDataObject ? loginDataObject.user.lastName : "",
    mobile: loginDataObject ? loginDataObject.user.mobile : "",
    dob:
      loginDataObject && loginDataObject.user.dob
        ? moment(loginDataObject.user.dob, "MM/DD/YYYY")
        : null,
    email: loginDataObject ? loginDataObject.user.email : "",
    gender: loginDataObject ? loginDataObject.user.gender : "",
    address1: loginDataObject ? loginDataObject.user.address1 : "",
    city: loginDataObject ? loginDataObject.user.city : "",
    state: loginDataObject ? loginDataObject.user.state : "",
    country: loginDataObject ? loginDataObject.user.country : "",
    pincode: loginDataObject ? loginDataObject.user.pincode : "",
    qualification: loginDataObject ? loginDataObject.user.qualification : "",
    speciality: loginDataObject.user.speciality
      ? loginDataObject.user.speciality
      : "",
    bankAccountName: loginDataObject.user.bankAccountName
      ? loginDataObject.user.bankAccountName
      : "",
    bankAccountNumber: loginDataObject.user.bankAccountNumber
      ? loginDataObject.user.bankAccountNumber
      : "",
    bankBranch: loginDataObject.user.bankBranch
      ? loginDataObject.user.bankBranch
      : "",
    bankName: loginDataObject.user.bankName
      ? loginDataObject.user.bankName
      : "",
    experience: loginDataObject.user.experience
      ? loginDataObject.user.experience
      : "",
    otherQualification: loginDataObject
      ? loginDataObject.user.otherQualification
      : "",
    userType: loginDataObject
      ? loginDataObject.user.userType === "P"
        ? "Physician"
        : "Nurse"
      : "",
  };

  const handleFileType = (e) => {
    const file = e.target.files[0];
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

    if (file && allowedTypes.includes(file.type)) {
      if (e.target.name === "sign") {
        setDoctorSignature(file);
      } else {
        setDoctorStamp(file);
      }
    } else {
      message.error("Only JPEG, JPG, and PNG files are allowed.");
      e.target.value = null;
    }
  };

  const handleSignatureUpdate = async () => {
    let payload = loginDataObject.user;
    if (doctorSignature) {
      const res = await encodeBase64File(doctorSignature);
      payload.doctorSignatureName = doctorSignature.name;
      if (doctorSignature.type.includes("pdf")) {
        payload.doctorSignatureType = "pdf";
        payload.doctorSignature = res;
      } else if (doctorSignature.type.includes("png")) {
        payload.doctorSignatureType = "png";
        payload.doctorSignature = res;
      } else if (doctorSignature.type.includes("jpg")) {
        payload.doctorSignatureType = "jpg";
        payload.doctorSignature = res;
      } else if (doctorSignature.type.includes("jpeg")) {
        payload.doctorSignatureType = "jpeg";
        payload.doctorSignature = res;
      }

      try {
        await DoctorService.editDoctorDetails(payload, payload.id);
        setDoctorSignature(null);
        setIsDoctorSignEnabled(false);
        closeModal();
      } catch (e) {
        console.error(e);
      }
    }
  };

  const handleStampUpdate = async () => {
    let payload = loginDataObject.user;
    if (doctorStamp) {
      const res = await encodeBase64File(doctorStamp);
      payload.doctorStampName = doctorStamp.name;
      if (doctorStamp.type.includes("png")) {
        payload.doctorStampType = "png";
        payload.doctorStamp = res;
      } else if (doctorStamp.type.includes("jpg")) {
        payload.doctorStampType = "jpg";
        payload.doctorStamp = res;
      } else if (doctorStamp.type.includes("jpeg")) {
        payload.doctorStampType = "jpeg";
        payload.doctorStamp = res;
      }
    }
    try {
      await DoctorService.editDoctorDetails(payload, payload.id);
      setDoctorStamp(null);
      setIsDoctorStampEnabled(false);
      closeModal();
    } catch (e) {
      console.error(e);
    }
  };

  const handleSave = async () => {
    setLoading(true);

    let payload = loginDataObject.user;

    if (doctorStamp) {
      const res = await encodeBase64File(doctorStamp);
      payload.doctorStampName = doctorStamp.name;
      if (doctorStamp.type.includes("png")) {
        payload.doctorStampType = "png";
        payload.doctorStamp = res;
      } else if (doctorStamp.type.includes("jpg")) {
        payload.doctorStampType = "jpg";
        payload.doctorStamp = res;
      } else if (doctorStamp.type.includes("jpeg")) {
        payload.doctorStampType = "jpeg";
        payload.doctorStamp = res;
      }
    }
    if (doctorSignature) {
      const res = await encodeBase64File(doctorSignature);
      payload.doctorSignatureName = doctorSignature.name;
      if (doctorSignature.type.includes("png")) {
        payload.doctorSignatureType = "png";
        payload.doctorSignature = res;
      } else if (doctorSignature.type.includes("jpg")) {
        payload.doctorSignatureType = "jpg";
        payload.doctorSignature = res;
      } else if (doctorSignature.type.includes("jpeg")) {
        payload.doctorSignatureType = "jpeg";
        payload.doctorSignature = res;
      }
    }
    try {
      await DoctorService.editDoctorDetails(payload, payload.id);
      setDoctorStamp(null);
      setDoctorSignature(null);
      setIsDoctorStampEnabled(false);
      message.success("Doctor Details Changed Successfully");
      closeModal();
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.error(e);
    }
    setLoading(false);
  };

  const getDoctorDetails = async () => {
    setLoading(true);
    try {
      const response = await DoctorService.getDoctorData(
        loginDataObject.user.userId,
      );
      setDoctorData(response.data[0]);
      setLoading(false);
      return response;
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    getDoctorDetails();
  }, []);

  const handleCountryChange = (countryId) => {
    form.setFieldsValue({ state: undefined });

    getStateList({
      countryId: countryId,
      status: 1,
    });
  };

  return (
    <div>
      {loading && (
        <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="spinner"></div>
        </div>
      )}
      <Form
        className="formDesign patientForm mt-7 mb-10"
        name="basic"
        layout="vertical"
        autoComplete="off"
        form={form}
        initialValues={initialValues}
        disabled={componentDisabled}
        // onFinish={handleSubmit}
      >
        <p className="font-semibold md:text-lg text-sm mb-4">
          Personal Details
        </p>
        <Row gutter={20}>
          <Col span={6}>
            <div className="flex flex-col m-auto mb-2">
              <div className="Upload h-24 w-24 border-2 border-dashed p-4 rounded-full cursor-pointer relative">
                <input type="file" style={{ display: "none" }} />
                <div
                  className="absolute bottom-0 right-0 rounded-full text-center p-1 bg-slate-300 cursor-pointer"
                  style={{ width: "24px", height: "24px", zIndex: 1 }}
                >
                  <PlusOutlined style={{}} />
                </div>
                {loginDataObject.user.imageName && profileImage === null ? (
                  <img
                    src={
                      process.env.REACT_APP_IMAGE_URL +
                      loginDataObject.user.imageName
                    }
                    alt="Profile"
                    className="absolute top-0 left-0 w-full h-full object-cover rounded-full"
                  />
                ) : (
                  <img
                    src={profileImage}
                    alt="Profile"
                    className="absolute top-0 left-0 w-full h-full object-cover rounded-full"
                  />
                )}
              </div>
            </div>
          </Col>
          <Col span={6}>
            <Form.Item
              label={
                <span>
                  User Id
                  <span style={{ color: "#FF000F" }}> *</span>
                </span>
              }
              name="userId"
              // rules={[
              //   {
              //     required: true,
              //     message: "Please input id!",
              //   },
              // ]}
            >
              <Input></Input>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label={
                <span>
                  Salutation
                  <span style={{ color: "#FF000F" }}> *</span>
                </span>
              }
              name="salutation"
              // rules={[
              //   {
              //     required: true,
              //     message: "Please input salutation!",
              //   },
              // ]}
            >
              <Select options={salutationOptions} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label={
                <span>
                  First Name
                  <span style={{ color: "#FF000F" }}> *</span>
                </span>
              }
              name="firstName"
              // rules={[
              //   {
              //     required: true,
              //     message: "Please Enter your First Name!",
              //   },
              // ]}
            >
              <Input className="w-full" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label={
                <span>
                  Last Name
                  <span style={{ color: "#FF000F" }}> *</span>
                </span>
              }
              name="lastName"
              // rules={[
              //   {
              //     required: true,
              //     message: "Please Enter Last Name!",
              //   },
              // ]}
            >
              <Input className="w-full" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label={
                <span>
                  Profession
                  <span style={{ color: "#FF000F" }}> *</span>
                </span>
              }
              name="userType"
              rules={[
                {
                  required: true,
                  message: "Please Enter Profession !",
                },
              ]}
            >
              <Input className="w-full" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label={
                <span>
                  D.O.B
                  <span style={{ color: "#FF000F" }}> *</span>
                </span>
              }
              name="dob"
              rules={[
                {
                  required: true,
                  message: "Please Enter your D.O.B!",
                },
              ]}
            >
              <DatePicker className="w-full" />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item label={<span>Marital Status</span>} name="maritalStatus">
              <Select className="w-full">
                {maritalStatusOptions.map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              label={
                <span>
                  Mobile Number
                  <span style={{ color: "#FF000F" }}> *</span>
                </span>
              }
              name="mobile"
              rules={[
                {
                  required: true,
                  message: "Please Enter your Mobile Number!",
                },
              ]}
            >
              <Input
                className="w-full"
                maxLength={15}
                onKeyPress={handleKeyPress}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label={
                <span>
                  Email ID
                  <span style={{ color: "#FF000F" }}> *</span>
                </span>
              }
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please Enter your Email ID!",
                },
              ]}
            >
              <Input className="w-full" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label={
                <span>
                  Gender
                  <span style={{ color: "#FF000F" }}> *</span>
                </span>
              }
              name="gender"
              rules={[
                {
                  required: true,
                  message: "Please Enter your Gender!",
                },
              ]}
            >
              <Select className="w-full"></Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label={
                <span>
                  Qualification
                  <span style={{ color: "#FF000F" }}> *</span>
                </span>
              }
              name="qualification"
            >
              <Input />
            </Form.Item>
          </Col>
          {loginDataObject.user.speciality && (
            <Col span={6}>
              <Form.Item
                label={
                  <span>
                    Speciality
                    <span style={{ color: "#FF000F" }}> *</span>
                  </span>
                }
                name="speciality"
              >
                <Input />
              </Form.Item>
            </Col>
          )}
          {loginDataObject.user.otherQualification && (
            <Col span={6}>
              <Form.Item
                label={
                  <span>
                    Other Qualification
                    <span style={{ color: "#FF000F" }}> *</span>
                  </span>
                }
                name="otherQualification"
              >
                <Input />
              </Form.Item>
            </Col>
          )}
          {loginDataObject.user.experience && (
            <Col span={6}>
              <Form.Item
                label={
                  <span>
                    Experience
                    <span style={{ color: "#FF000F" }}> *</span>
                  </span>
                }
                name="experience"
              >
                <Input />
              </Form.Item>
            </Col>
          )}
          {loginDataObject.user.bankAccountName && (
            <Col span={6}>
              <Form.Item
                label={
                  <span>
                    Account Name
                    <span style={{ color: "#FF000F" }}> *</span>
                  </span>
                }
                name="bankAccountName"
              >
                <Input />
              </Form.Item>
            </Col>
          )}
          {loginDataObject.user.bankAccountNumber && (
            <Col span={6}>
              <Form.Item
                label={
                  <span>
                    Account Number
                    <span style={{ color: "#FF000F" }}> *</span>
                  </span>
                }
                name="bankAccountNumber"
              >
                <Input />
              </Form.Item>
            </Col>
          )}
          {loginDataObject.user.bankBranch && (
            <Col span={6}>
              <Form.Item
                label={
                  <span>
                    Bank Branch
                    <span style={{ color: "#FF000F" }}> *</span>
                  </span>
                }
                name="bankBranch"
              >
                <Input />
              </Form.Item>
            </Col>
          )}
          {loginDataObject.user.bankName && (
            <Col span={6}>
              <Form.Item
                label={
                  <span>
                    Bank Name
                    <span style={{ color: "#FF000F" }}> *</span>
                  </span>
                }
                name="bankName"
              >
                <Input />
              </Form.Item>
            </Col>
          )}
        </Row>
        <div className="font-semibold text-lg mb-4">Address Details</div>
        <Row gutter={24}>
          <Col span={6}>
            <Form.Item
              label={
                <span>
                  House No/Street Name
                  <span style={{ color: "#FF000F" }}> *</span>
                </span>
              }
              name="house no"
              // rules={[
              //   {
              //     required: true,
              //     message: "Please Enter your House No!",
              //   },
              // ]}
            >
              <Input className="w-full" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label={
                <span>
                  Address
                  <span style={{ color: "#FF000F" }}> *</span>
                </span>
              }
              name="address1"
              // rules={[
              //   {
              //     required: true,
              //     message: "Please Enter your Address",
              //   },
              // ]}
            >
              <Input className="w-full" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label={
                <span>
                  City
                  <span style={{ color: "#FF000F" }}> *</span>
                </span>
              }
              name="city"
              // rules={[
              //   {
              //     required: true,
              //     message: "Please Enter your City",
              //   },
              // ]}
            >
              <Input className="w-full" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="Country" name="country">
              <Select
                placeholder="Select Country"
                onChange={handleCountryChange}
              >
                {countries?.map((c) => (
                  <Select.Option key={c.country_Id} value={c.country_Id}>
                    {c.country_Name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="State" name="state">
              <Select placeholder="Select State">
                {states?.map((state) => (
                  <Select.Option key={state.stateId} value={state.stateId}>
                    {state.stateName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              label={<span>Pincode</span>}
              name="pincode"
              // rules={[
              //   {
              //     required: true,
              //     message: "Please Enter your Pincode",
              //   },
              // ]}
            >
              <Select
                className="w-full"
                maxLength={6}
                // onKeyPress={handleKeyPress}
              ></Select>
            </Form.Item>
          </Col>
        </Row>

        <div className="w-full flex">
          <div className="my-3 w-full flex items-center gap-4">
            <div className="my-3 w-[80%]">
              {doctorStamp ? (
                <img
                  id="imag"
                  src={URL.createObjectURL(doctorStamp)}
                  alt="Stamp"
                  className="md:h-32 h-28 md:w-36 w-30 rounded-full"
                />
              ) : (
                <img
                  id="imag"
                  src={`${process.env.REACT_APP_IMAGE_URL}${doctorData?.doctorStampName}`}
                  alt="Stamp"
                  className="md:h-32 h-28 md:w-36 w-30 rounded-full"
                />
              )}
              <div className="my-2">
                <div className="my-2">
                  <label className="md:text-lg text-base font-medium">
                    Stamp
                  </label>
                  <span className="text-red-500">*</span>
                </div>
                <Form.Item
                  className="mb-0 w-full outline-none rounded-lg"
                  name="stamp"
                >
                  <div
                    className={`flex flex-col justify-center border-2 ${
                      isDoctorStampEnabled
                        ? "border-brand-primaryColor"
                        : "border-brand-textGray"
                    } relative md:h-12 h-10 p-2 rounded-lg`}
                  >
                    <BsCloudUpload
                      className={`mx-auto text-lg ${
                        isDoctorStampEnabled
                          ? "text-brand-primaryColor"
                          : "text-brand-textGray"
                      }`}
                    />
                    <input
                      type="file"
                      name="stamp"
                      // disabled={!isDoctorStampEnabled}
                      className="w-[inherit] border-none outline-none ml-[2.75rem] absolute left-8  opacity-0"
                      onChange={handleFileType}
                    />
                  </div>
                </Form.Item>
                {(doctorStamp || loginDataObject.user.doctorStampName) && (
                  <p>
                    {doctorStamp
                      ? doctorStamp.name
                      : loginDataObject.user.doctorStampName
                        ? loginDataObject.user.doctorStampName
                        : "No Image Found"}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className="my-3 w-full flex items-center gap-4">
            <div className="my-2 w-[80%]">
              {doctorSignature ? (
                <img
                  src={URL.createObjectURL(doctorSignature)}
                  alt="Signature"
                  className="md:w-28 w-20 md:h-28 h-20  rounded-full"
                />
              ) : (
                <img
                  src={`${process.env.REACT_APP_IMAGE_URL}${doctorData?.doctorSignatureName}`}
                  alt="Signature"
                  className="md:w-28 w-20 md:h-28 h-20  rounded-full"
                />
              )}
              <div className="my-2">
                <label className="md:text-lg text-base font-medium">
                  Signature
                </label>
                <span className="text-red-500">*</span>
              </div>
              <Form.Item
                className="mb-0 outline-none rounded-lg"
                name="signature"
              >
                <div
                  className={`flex flex-col justify-center border-2 ${
                    isDoctorSignEnabled
                      ? "border-brand-primaryColor"
                      : "border-brand-textGray"
                  } relative md:h-12 h-10 p-2 rounded-lg`}
                >
                  <BsCloudUpload
                    className={`mx-auto text-lg ${
                      isDoctorSignEnabled
                        ? "text-brand-primaryColor"
                        : "text-brand-textGray"
                    }`}
                  />
                  <input
                    type="file"
                    name="sign"
                    // disabled={!isDoctorSignEnabled}
                    className="w-[inherit] border-none outline-none ml-[2.75rem] absolute left-8  opacity-0"
                    onChange={handleFileType}
                  />
                </div>
              </Form.Item>
              {(doctorSignature ||
                loginDataObject.user.doctorSignatureName) && (
                <p>
                  {doctorSignature
                    ? doctorSignature.name
                    : loginDataObject.user.doctorSignatureName
                      ? loginDataObject.user.doctorSignatureName
                      : "No Image Found"}
                </p>
              )}
            </div>
          </div>
        </div>
        <Row gutter={24}>
          <Col span={24}>
            <div
              className={`flex justify-end ${
                !componentDisabled ? "block" : "block"
              } gap-3 `}
            >
              <button
                onClick={closeModal}
                className="px-2 py-1 w-20 rounded bg-transparent border shadow"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="px-2 py-1 w-20 rounded text-white "
              >
                Save
              </button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default Index;
